import styled from '@emotion/styled';
import { Ui } from '@silvertours/front-shared';

const Block = styled.section<{
  isHidden: boolean;
  textStyle: Ui.RichTextStyle;
}>`
  padding-top: ${({ theme }) => theme.spacing[60]};

  & > :first-of-type h1,
  & > :first-of-type h2,
  & > :first-of-type h3,
  & > :first-of-type h4,
  & > :first-of-type h5,
  & > :first-of-type h6 {
    margin-top: 0;
    padding-top: 0;
  }

  display: ${({ isHidden }) => (isHidden ? 'none' : 'block')};
  color: ${({ textStyle, theme }) =>
    textStyle === Ui.RichTextStyle.Alternative
      ? theme.colors.neutral.white100
      : theme.colors.neutral.grey160};

  &:focus-visible {
    border-radius: ${({ theme }) => theme.radius.xs};
    outline: 0.125rem dashed ${({ theme }) => theme.colors.brand.orange100};
    outline-offset: 0.25rem;
  }
`;

export { Block };
